/**
 * Speaker Selection Utilities
 *
 * Types and helper functions for managing speaker/partner selection
 * in reflection creation flows.
 */

/**
 * Represents the user's selection of who the reflection is with
 */
export type SpeakerSelection =
  | { type: "primary"; partnerId: string | null }
  | { type: "other"; partnerId: string }
  | { type: "new"; name: string; pronouns?: string };

/**
 * Helper to get the final partner ID and is_with_primary_partner flag from selection
 */
export function resolvePartnerSelection(
  selection: SpeakerSelection,
  primaryPartnerId: string | null
): {
  conversation_partner_id: string | null;
  is_with_primary_partner: boolean;
} {
  switch (selection.type) {
    case "primary":
      return {
        conversation_partner_id: primaryPartnerId,
        is_with_primary_partner: true,
      };
    case "other":
      return {
        conversation_partner_id: selection.partnerId,
        is_with_primary_partner: false,
      };
    case "new":
      // The partner should have been created by now if name was provided
      // This case shouldn't happen in practice as we create inline
      return {
        conversation_partner_id: null,
        is_with_primary_partner: false,
      };
  }
}
